/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from 'reactstrap';

class ErrorBoundaryMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // componentDidCatch(error, errorInfo) {
  //   // You can also log the error to an error reporting service
  //   logErrorToMyService(error, errorInfo);
  // }

  render() {
    const {hasError} = this.state;
    const { children } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <span style={{margin:'2rem',fontSize:'2rem'}}>
        Something went wrong. Please Contact System Admin.
          </span>
          <Button
            color="danger"
            onClick={() => {
              localStorage.clear();
              window.location.reload();
          }}
          >
Logout

          </Button>
        </>
        )
    }

    return children;
  }
}

export default ErrorBoundaryMain;
